<th class="flex text-12-caps text-center uppercase items-center justify-center whitespace-normal break-words min-w-[100px] h-[60px]" [ngClass]="{'hover:cursor-pointer': sortable}" (click)="triggerSort()">
  <ng-content />
  <ng-container *ngIf="sorted">
    <div *ngIf="sort === 'asc'">&#9650;</div>
    <div *ngIf="sort === 'desc'">&#9660;</div>
  </ng-container>
</th>
